/**
 * SpeechBubble — speech bubble with SVG tail for mascot "speaking"
 */

import { ReactNode } from 'react';

interface SpeechBubbleProps {
  children: ReactNode;
  direction?: 'left' | 'right';
  color?: string;
  className?: string;
}

export default function SpeechBubble({
  children,
  direction = 'left',
  color = 'var(--kid-surface)',
  className = '',
}: SpeechBubbleProps) {
  return (
    <div className={`relative ${className}`}>
      <div
        className="rounded-kid p-5 shadow-kid border-2 border-kid-ocean/15 wobble-2"
        style={{ backgroundColor: color }}
      >
        {children}
      </div>
      {/* Tail */}
      <svg
        width="20"
        height="16"
        viewBox="0 0 20 16"
        fill="none"
        className={`absolute -bottom-3.5 ${direction === 'left' ? 'left-6' : 'right-6'} pointer-events-none`}
        style={{ transform: direction === 'right' ? 'scaleX(-1)' : undefined }}
      >
        <path
          d="M0 0C4 0 8 4 10 10C10 10 12 4 20 0"
          fill={color}
        />
        <path
          d="M0 0C4 0 8 4 10 10C10 10 12 4 20 0"
          stroke="rgba(34, 184, 207, 0.15)"
          strokeWidth={2}
          fill="none"
        />
      </svg>
    </div>
  );
}
